import { RequestAction } from '@redux-requests/core'
import { UserSettings } from '../../../pages/Account/Account'
import { SignUpFormData, User } from './auth.types'

export const SIGN_UP = 'SIGN_UP'
export const GET_USER_BY_UID = 'GET_USER_BY_UID'
export const GET_WHITELIST = 'GET_WHITELIST'
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS'
export const SEND_EMAIL_VERIFICATION = 'SEND_EMAIL_VERIFICATION'
export const SEND_PASSWORD_RESET = 'SEND_PASSWORD_RESET'

const signUp = (formData: SignUpFormData, dispatch: any): any => ({
  type: SIGN_UP,
  // request: {
  //   url: '/users/signup',
  //   method: 'POST',
  // },
  data: {
    ...formData,
  },
  dispatch,
})

const getUserByUid = (userId: User['id']): RequestAction => ({
  type: GET_USER_BY_UID,
  request: {
    url: `/users/${userId}`,
    method: 'GET',
  },
})
const getWhitelist = (userId: User['id']): RequestAction => ({
  type: GET_WHITELIST,
  request: {
    url: `/users/getwhitelist/userid/${userId}`,
    method: 'GET',
  },
})
const updateUserSettings = (userId: User['id'], data: UserSettings): RequestAction => {
  console.log('update', { data })
  return {
    type: SET_USER_SETTINGS,
    request: {
      url: `/users/updateusersettings/userid/${userId}`,
      method: 'POST',
      data,
    },
  }
}

const sendEmailVerification = (data: any): RequestAction => ({
  type: SEND_EMAIL_VERIFICATION,
  request: {
    url: `/users/send-signup-verification`,
    method: 'POST',
    data,
  },
})
const sendPasswordReset = (data: any): RequestAction => ({
  type: SEND_EMAIL_VERIFICATION,
  request: {
    url: `/users/reset-password`,
    method: 'POST',
    data,
  },
})

const authActions = {
  signUp,
  getUserByUid,
  getWhitelist,
  updateUserSettings,
  sendEmailVerification,
  sendPasswordReset,
}

export default authActions
